import { useQuery } from '@tanstack/react-query';
import type { PartResponseDto } from '@evimo/client/models';
import { SystemRoleName } from '@evimo/types/enums/system-role-name';
import { useAuth } from '~/app/auth/context/AuthContext';
import { PreventiveMaintenanceService } from '~/app/services/preventive-maintenance/preventive-maintenance.service';

export function useParts() {
  const { user } = useAuth();
  const isSuperAdmin = user?.roleName === SystemRoleName.SUPER_ADMIN;
  const organizationId = user?.organizationId ?? '';
  const scopeKey = isSuperAdmin ? 'all-orgs' : organizationId;

  const query = useQuery({
    queryKey: ['preventive-maintenance', 'parts', scopeKey] as const,
    queryFn: async (): Promise<PartResponseDto[]> => {
      const res = await PreventiveMaintenanceService.listParts(1, 100);
      return res.data;
    },
    enabled: isSuperAdmin || !!organizationId,
  });

  const parts: PartResponseDto[] = query.data ?? [];

  return {
    data: parts,
    parts,
    isLoading: query.isLoading,
    error: (query.error ?? null) as Error | null,
  };
}
